import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DwComponent, DwComponentSectionPreference, DwComponentType, DwExpressionService, DwFormContextMode, DwMetaDataService, DwMetaDataServiceToken, DwOrmDataService, DwOrmDataServiceToken, DwQueryHelper, DwSectionBaseComponent, DwUiConfigRegistryService, DwUIMetaDataConfig, DwUIMetaDataConfigToken, getParameterByName } from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { result } from 'underscore';
import { KickoffEntity, KickoffMetaDataItemNames, KickoffMetaDataService } from '../../meta-data/kickoff-meta-data.service';

@DwComponent(
  {
    key: 'copy-kickoff-button',
    name: 'Copy Kickoff Document',
    componentType: DwComponentType.formSection,
    isGlobal: false,
    parentItemName: KickoffMetaDataItemNames.Kickoff,
  }
)
@Component({
  selector: 'app-copy-kickoff-button',
  template: ''
})
export class CopyKickoffButtonComponent extends DwSectionBaseComponent<DwComponentSectionPreference>
  implements OnInit {

  constructor(@Inject(DwOrmDataServiceToken) private dwOrmDataService: DwOrmDataService,
    dwExpressionService: DwExpressionService,
    protected dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    private router: Router,
  ) {
    super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
  }

  setupComponentComplete() {
    if (!this.formGroup || !this.formConfig) {
      return;
    }
    if (this.formConfig.formMode == DwFormContextMode.add) {
      this.copyKickoffTemplateId();
    }
  }
  copyKickoffTemplateId() {

    const copyKickoffId = getParameterByName(this.router, 'copyKickoffId');

    if(copyKickoffId == null){
      return;
    }

    this.loadKickoff(copyKickoffId).subscribe(result => {
      const copiedKickoffDocument = result;
      this.setKickoffDocument(copiedKickoffDocument);
    });
  }

  loadKickoff(copyKickoffId: number) : Observable<KickoffEntity> {
    const md = new KickoffMetaDataService();
    const qh = new DwQueryHelper();

    const query = md.Kickoff.CreateQuery();

    query.AddFilterAnd(qh.filters.Equal(md.Kickoff.KickoffId,copyKickoffId));
   
    query.AddPrefetchPath(md.Kickoff.Relations.RoKickoff);
    query.AddPrefetchPath(md.Kickoff.Relations.Milestone);

    query.FieldSettings.LoadAllLookupDisplayFields = true;

    return this.dwOrmDataService.executeQuerySingle(query);
  }

  setKickoffDocument(copiedKickoffDocument: KickoffEntity) {

    copiedKickoffDocument.Milestone.forEach(x => {
      x.KickoffId = null;
    })
    copiedKickoffDocument.Ethos_JobNumberId = null;
    copiedKickoffDocument.ChangeOrderProcessDescription = null;
    copiedKickoffDocument.KickoffId = null;

    this.formGroup.patchValue(copiedKickoffDocument);
  }
}
